import moment from "moment";
import debounce from "lodash.debounce";

import type { Moment } from "moment";

export class DateValidation {
  public static minimumDate: Moment = moment("1900 01 01", "YYYY MM DD", true);
  public feedbackMessage = "";
  private dateAsMoment: Moment | null = null;
  private internalDate = "";

  constructor() {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.validate = debounce(this.validate, 750);
  }

  public get date(): string {
    return this.internalDate;
  }
  public set date(value: string) {
    this.internalDate = value;
    this.validate();
  }
  public get valid(): boolean {
    return this.feedbackMessage === "";
  }

  public get moment(): Moment | null {
    return this.dateAsMoment;
  }

  public clear(): void {
    this.internalDate = "";
    this.dateAsMoment = null;
    this.feedbackMessage = "";
  }

  private validate() {
    if (this.internalDate === "") {
      this.clear();
      return;
    }

    this.dateAsMoment = moment(this.internalDate, "YYYY MM DD", true);
    if (!this.dateAsMoment.isValid()) {
      this.dateAsMoment = moment(this.internalDate);
    }

    if (!this.dateAsMoment.isValid()) {
      this.feedbackMessage = `Date should be in 'YYYY MM DD' format`;
      this.dateAsMoment = null;
      return;
    }

    if (this.dateAsMoment.isAfter(moment())) {
      this.feedbackMessage = `Date cannot be greater than ${moment().format("YYYY MM DD")}`;
      this.dateAsMoment = null;
      return;
    }

    if (this.dateAsMoment.isBefore(DateValidation.minimumDate)) {
      this.feedbackMessage = `Date cannot be earlier than ${DateValidation.minimumDate.format("YYYY MM DD")}`;
      this.dateAsMoment = null;
      return;
    }
    this.feedbackMessage = "";
  }
}
